// extracted by mini-css-extract-plugin
export default {"container":"Up-z","ratingLayout":"Vp-z","ratingLabel":"Wp-z","nonInteractiveRatingLabel":"Xp-z"};